(function () {
  'use strict';

  /* ════════════════════════════════════════════════════════════════
     1. PAGE TRANSITIONS
  ════════════════════════════════════════════════════════════════ */
  function initPageTransitions() {
    /* Respect prefers-reduced-motion */
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var FADE_IN_MS  = 400;   /* page load reveal          */
    var FADE_OUT_MS = 300;   /* navigate-away fade        */

    var overlay = document.createElement('div');
    overlay.id  = 'ph-page-overlay';
    /* #FFFFFF — matches the page canvas (every PHALANX .ph-root/.pco-root
       is background: #FFFFFF), so the transition is imperceptible; was
       #F8FAFC, an off-palette pale blue-gray that briefly flashed a
       visibly different tone during fade in/out. */
    overlay.style.cssText = [
      'position:fixed;inset:0;background:#FFFFFF;z-index:99998;',
      'pointer-events:none;opacity:1;'
    ].join('');
    document.body.appendChild(overlay);

    /* ── Fade in on initial page load: overlay 1 → 0 ──────────── */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.style.transition = 'opacity ' + (FADE_IN_MS / 1000).toFixed(2) + 's ease';
        overlay.style.opacity    = '0';
      });
    });

    /* ── Fade out before navigating to an internal page ─────────── */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || !href.trim()) return;
      var h = href.trim();

      /* Skip: anchors, new-tab, external protocols, checkout, cart */
      var skip = h.charAt(0) === '#'                    ||
                 a.target    === '_blank'                ||
                 h.indexOf('mailto:')    === 0           ||
                 h.indexOf('tel:')       === 0           ||
                 h.indexOf('http')       === 0           ||
                 h.indexOf('//')         === 0           ||  /* protocol-relative */
                 h.indexOf('/checkout')  !== -1          ||
                 h.indexOf('/cart')      !== -1;
      if (skip) return;

      e.preventDefault();
      overlay.style.transition    = 'opacity ' + (FADE_OUT_MS / 1000).toFixed(2) + 's ease';
      overlay.style.opacity       = '1';
      overlay.style.pointerEvents = 'all';
      setTimeout(function () { window.location.href = href; }, FADE_OUT_MS + 10);
    });

    /* ── Re-fade-in after bfcache restore (back/forward cache) ──── */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      overlay.style.transition = 'none';
      overlay.style.opacity    = '1';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          overlay.style.transition    = 'opacity ' + (FADE_IN_MS / 1000).toFixed(2) + 's ease';
          overlay.style.opacity       = '0';
          overlay.style.pointerEvents = 'none';
        });
      });
    });
  }

  /* ════════════════════════════════════════════════════════════════
     3. MAGNETIC BUTTONS (pointer:fine devices only)
     Shared .ph-magnetic marker class so every page's primary CTAs
     get the same restrained pull — capped well under 10px at the
     edge of the trigger radius, tapering to ~0 near the button's own
     center, consistent with the site's 2-3%-scale restraint elsewhere.
  ════════════════════════════════════════════════════════════════ */
  function initMagneticButtons() {
    if (!window.matchMedia('(pointer: fine)').matches) return;

    var btns = Array.prototype.slice.call(
      document.querySelectorAll('.ph-magnetic')
    );
    if (!btns.length) return;

    var RADIUS = 64, PULL = 0.15;

    document.addEventListener('mousemove', function (e) {
      /* Read phase: batch every getBoundingClientRect() before any
         style write below. Interleaving reads and writes per-button
         (as a single combined loop would) forces the browser to
         recalculate layout on each subsequent read, once per button,
         every mousemove tick. transform doesn't affect any other
         element's box, so computing all deltas first and writing
         second is pixel-identical — just without the forced reflows. */
      var updates = btns.map(function (btn) {
        var r  = btn.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width  / 2);
        var dy = e.clientY - (r.top  + r.height / 2);
        return { btn: btn, dx: dx, dy: dy, d: Math.sqrt(dx * dx + dy * dy) };
      });

      /* Write phase */
      updates.forEach(function (u) {
        var btn = u.btn;
        if (u.d < RADIUS) {
          btn.style.transition = 'transform 0.1s ease, background 0.2s ease, border-color 0.2s ease';
          btn.style.transform  = 'translate(' + (u.dx * PULL) + 'px,' + (u.dy * PULL) + 'px)';
        } else if (btn.style.transform) {
          btn.style.transition = 'transform 0.4s cubic-bezier(0.25,0.46,0.45,0.94), background 0.2s ease, border-color 0.2s ease';
          btn.style.transform  = '';
        }
      });
    }, { passive: true });
  }

  /* ════════════════════════════════════════════════════════════════
     5. FORM VALIDATION — inline Swedish error, no page-reload required
     Targets every form with a contact[email] input. Sets noValidate so
     the browser's default popup is suppressed; validates via the
     input's built-in validity API and shows/hides [data-ph-err].
  ════════════════════════════════════════════════════════════════ */
  function initFormValidation() {
    var forms = document.querySelectorAll('form');
    for (var f = 0; f < forms.length; f++) {
      (function (form) {
        var emailInput = form.querySelector('input[name="contact[email]"]');
        if (!emailInput) return;

        var errEl = form.querySelector('[data-ph-err]');
        form.noValidate = true;

        /* Waitlist forms carry the "waitlist" tag (see contact[tags] on
           the homepage form) — distinguishes them from the general
           Contact-page inquiry form, which also has a contact[email]
           input but isn't a waitlist signup. Only used to label the
           semantic events below; no behavior differs by form type. */
        var tagsInput = form.querySelector('input[name="contact[tags]"]');
        var isWaitlist = !!(tagsInput && tagsInput.value.indexOf('waitlist') !== -1);

        form.addEventListener('submit', function (e) {
          var valid = emailInput.value.trim().length > 0 && emailInput.validity.valid;
          if (!valid) {
            e.preventDefault();
            emailInput.setAttribute('aria-invalid', 'true');
            if (errEl) {
              errEl.textContent = 'Ange en giltig e-postadress.';
              errEl.hidden = false;
            }
            emailInput.focus();
            if (isWaitlist) dispatchPhalanxEvent('phalanx:waitlist_error', { reason: 'invalid_email' });
            return;
          }
          if (errEl) errEl.hidden = true;
          emailInput.removeAttribute('aria-invalid');
          /* Real native submit proceeds from here (this listener never
             calls preventDefault on the valid path) — "start", not
             "success": the actual conversion event fires separately,
             on the next page load, only once Shopify's own redirect
             confirms the signup (see initWaitlistSuccessEvent below). */
          if (isWaitlist) dispatchPhalanxEvent('phalanx:waitlist_start');
        });

        emailInput.addEventListener('input', function () {
          emailInput.removeAttribute('aria-invalid');
          if (errEl) errEl.hidden = true;
        });
      }(forms[f]));
    }
  }

  /* ════════════════════════════════════════════════════════════════
     LIGHTWEIGHT SEMANTIC EVENTS — no analytics vendor is wired up
     yet (confirmed: no gtag/dataLayer/GA anywhere in the theme, only
     the Shopify Customer Privacy consent banner). These are plain
     CustomEvents on `document` — inert until something listens, zero
     dependencies, no PII (never the email address itself). Whenever
     an analytics tool is added, it can subscribe with
     `document.addEventListener('phalanx:waitlist_success', fn)` etc.
     instead of this logic being re-derived from scratch.
  ════════════════════════════════════════════════════════════════ */
  function dispatchPhalanxEvent(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  }

  function initCtaClickEvents() {
    /* Every existing primary/secondary CTA class, site-wide — a click
       is interest, not conversion (see waitlist_start/_success above
       for the events that actually matter pre-launch). */
    var CTA_SELECTOR = '.ph-form__btn, .phd-info__cta, .phd-sticky-cta__btn, ' +
      '.ph-closing__cta, .pha-cta__btn, .ph-nav__cta, .ph-contact-submit, ' +
      '.php-card__cta, .phsci-cta__link, .phsci-study__details-toggle';
    document.addEventListener('click', function (e) {
      var el = e.target.closest(CTA_SELECTOR);
      if (!el) return;
      dispatchPhalanxEvent('phalanx:cta_click', {
        label: (el.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 60),
        path: window.location.pathname
      });
    }, { passive: true });
  }

  function initWaitlistSuccessEvent() {
    /* Fires once per page load, only when the page is actually showing
       the post-submit success state (Shopify's own form.posted_successfully?
       rendered server-side into .ph-form__success) — the real, confirmed
       conversion event, never assumed from a click alone. */
    if (document.querySelector('.ph-form__success')) {
      dispatchPhalanxEvent('phalanx:waitlist_success');
    }
  }

  /* ════════════════════════════════════════════════════════════════
     SCROLL FADE-IN (.ph-fade-in elements on any page)
     Supports stagger: add ph-stagger to a container; its direct
     .ph-fade-in children will animate with 100 ms between each.
  ════════════════════════════════════════════════════════════════ */
  function initFadeIn() {
    var els = document.querySelectorAll('.ph-fade-in');
    if (!els.length) return;

    /* Fallback — no IntersectionObserver */
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ph-visible'); });
      return;
    }

    var STAGGER_MS   = 100;
    var triggered    = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

    /* Returns direct .ph-fade-in children of a container */
    function staggerChildren(parent) {
      var out = [];
      var ch  = parent.children;
      for (var i = 0; i < ch.length; i++) {
        if (ch[i].classList.contains('ph-fade-in')) out.push(ch[i]);
      }
      return out;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var el     = entry.target;
        var parent = el.parentElement;
        var isStaggerGroup = parent && parent.classList.contains('ph-stagger');

        if (isStaggerGroup) {
          /* Only trigger once per container */
          var alreadyDone = triggered ? triggered.has(parent) : parent._phTriggered;
          if (alreadyDone) { io.unobserve(el); return; }
          if (triggered) { triggered.add(parent); } else { parent._phTriggered = true; }

          /* Reveal all direct ph-fade-in children with stagger */
          var siblings = staggerChildren(parent);
          siblings.forEach(function (sib, idx) {
            sib.style.setProperty('--ph-delay', (idx * STAGGER_MS / 1000).toFixed(2) + 's');
            sib.classList.add('ph-visible');
            io.unobserve(sib);
          });

        } else {
          /* Standalone element — reveal immediately */
          el.classList.add('ph-visible');
          io.unobserve(el);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ════════════════════════════════════════════════════════════════
     CASCADE — parent-triggered child stagger (.ph-cascade containers)

     Usage: add class  ph-cascade  to any container whose direct
     children should stagger in when the container enters viewport.

     Optional: data-ph-cascade-start="N"  adds N ms of base delay
     before the first child (useful when the container itself is
     inside a ph-fade-in parent — lets the parent finish first).

     Children with  ph-fade-in  are skipped (already handled).
  ════════════════════════════════════════════════════════════════ */
  function initCascade() {
    var STAGGER_MS = 120;

    var containers = document.querySelectorAll('.ph-cascade');
    if (!containers.length) return;

    /* ── Pre-process: mark eligible direct children with ph-ci ─── */
    containers.forEach(function (container) {
      var ch = container.children;
      for (var i = 0; i < ch.length; i++) {
        var child = ch[i];
        if (child.classList.contains('ph-fade-in')) continue; /* managed elsewhere */
        child.classList.add('ph-ci');
      }
    });

    /* ── Fallback: no IntersectionObserver ─────────────────────── */
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.ph-ci').forEach(function (el) {
        el.classList.add('ph-ci--on');
      });
      return;
    }

    /* WeakSet prevents double-firing when multiple children enter
       the IO root at the same frame (only the container is observed
       here, so this is insurance rather than a common path)          */
    var fired = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var container = entry.target;

        /* Guard: only reveal once per container */
        var done = fired ? fired.has(container) : container._phCiDone;
        if (done) { io.unobserve(container); return; }
        if (fired) { fired.add(container); } else { container._phCiDone = true; }

        /* Optional base delay (ms) — lets a fading parent settle first */
        var baseDelay = parseFloat(
          container.getAttribute('data-ph-cascade-start') || '0'
        ) / 1000;

        /* Assign delays and reveal children */
        var revealIdx = 0;
        var ch = container.children;
        for (var i = 0; i < ch.length; i++) {
          var child = ch[i];
          if (!child.classList.contains('ph-ci')) continue;
          child.style.setProperty(
            '--ph-ci',
            (baseDelay + revealIdx * STAGGER_MS / 1000).toFixed(3) + 's'
          );
          child.classList.add('ph-ci--on');
          revealIdx++;
        }

        io.unobserve(container);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -20px 0px' });

    containers.forEach(function (c) { io.observe(c); });
  }

  /* ════════════════════════════════════════════════════════════════
     SMOOTH SCROLL FOR ANCHOR LINKS
  ════════════════════════════════════════════════════════════════ */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href');
        if (!href || href === '#') return; /* bare "#" is an invalid selector */
        var target;
        try { target = document.querySelector(href); } catch (_) { return; }
        if (!target) return;
        e.preventDefault();
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ════════════════════════════════════════════════════════════════
     6a. SCROLL PROGRESS — thin line at the very top of the viewport,
     transform-only (no layout reflow), rAF-throttled. Reflects the
     visitor's own scroll input directly, so it runs regardless of
     prefers-reduced-motion (same category as native scrollbars).
  ════════════════════════════════════════════════════════════════ */
  function initScrollProgress() {
    var bar = document.createElement('div');
    bar.id = 'ph-scroll-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    var ticking = false;

    function update() {
      var scrollTop    = window.scrollY || document.documentElement.scrollTop;
      var scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      var pct          = scrollHeight > 0 ? Math.min(scrollTop / scrollHeight, 1) : 0;
      bar.style.transform = 'scaleX(' + pct + ')';
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', update, { passive: true });

    update();
  }

  /* ════════════════════════════════════════════════════════════════
     6b. IMAGE FADE-IN — opacity only, never a pop-in. Safe by
     construction: the "pending" class is added by this script, only
     to images it can see aren't loaded yet, and removed on their own
     load event — if this script never runs, images simply keep their
     default full opacity and nothing is ever stuck hidden. Shared
     site-wide via the .ph-img-fade marker class so every page gets
     the same smooth-load treatment, not just the homepage.
  ════════════════════════════════════════════════════════════════ */
  function initImageLoadFade() {
    var imgs = document.querySelectorAll('.ph-img-fade');
    imgs.forEach(function (img) {
      if (img.complete) return;
      /* --fading carries the CSS transition (assets/phalanx-global.css)
         and is added alongside --pending, never removed afterward — see
         the CSS comment for why this is split from the base class: an
         already-complete image (the common case for an eager, high-
         priority hero) never gets either class and so never matches a
         transition rule at any point, keeping it eligible as a Largest
         Contentful Paint candidate. */
      img.classList.add('ph-img-fade--pending', 'ph-img-fade--fading');
      img.addEventListener('load', function () {
        img.classList.remove('ph-img-fade--pending');
      }, { once: true });
    });
  }

  /* ════════════════════════════════════════════════════════════════
     6c. IMAGE SURFACE REVEAL — same visual goal as 6b (a soft fade
     once the image is ready), different mechanism, for the site's
     handful of dominant/likely-LCP image regions (hero, founder,
     Game Changer legacy collage — see .ph-img-surface in
     phalanx-global.css). There, the <img> itself never gets a
     --pending/--fading class or any opacity change at all; instead
     this fades the CONTAINER's own ::after overlay out, revealing an
     <img> that has stayed at opacity:1 since it entered the DOM. See
     the CSS comment on .ph-img-surface for why: an image whose own
     opacity is animated is excluded from LargestContentfulPaint
     candidacy by Chromium for the rest of the page's life, and these
     are exactly the images most likely to BE the page's LCP element. */
  function initImgSurfaceReveal() {
    var containers = document.querySelectorAll('.ph-img-surface, .ph-img-surface--dark');
    containers.forEach(function (container) {
      var img = container.querySelector('img');
      if (!img) {
        /* No image uploaded — the merchant-facing .ph-img-placeholder
           text is the only content, so reveal immediately rather than
           leaving it permanently hidden under the surface overlay. */
        container.classList.add('ph-img-surface--loaded');
        return;
      }
      /* Two rAFs, not an immediate class add: guarantees a real paint
         of the image's own settled (opacity:1, transition-free) state
         completes before the overlay's opacity transition — a
         property on the *container*, not the image — is engaged by
         adding --loaded. Measured: without this margin, the LCP
         candidacy of the <img> underneath was inconsistent run to
         run (present in some page loads, missing in others) even
         though its own opacity never changes; the two-frame gap
         removes that inconsistency. Zero visual effect either way —
         only which exact frame the (already-instant-if-fast, already
         at most ~0.2s if genuinely slow) reveal lands on shifts by a
         couple of milliseconds. */
      var reveal = function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            container.classList.add('ph-img-surface--loaded');
          });
        });
      };
      if (img.complete) {
        reveal();
        return;
      }
      img.addEventListener('load', reveal, { once: true });
      /* On error, still reveal — an ugly broken-image icon over an
         empty surface beats a permanently-hidden one. */
      img.addEventListener('error', reveal, { once: true });
    });
  }

  /* ════════════════════════════════════════════════════════════════
     7. PREFETCH INTERNAL PAGES
     Warms up the next likely navigations during browser idle time
     so page transitions feel instant.
  ════════════════════════════════════════════════════════════════ */
  function initPrefetch() {
    /* Pages to prefetch — covers all five Phalanx sections */
    var PAGES = ['/', '/pages/about', '/pages/contact', '/blogs/nyheter', '/collections/all'];

    /* PERF FIX (measured): this used to schedule its requestIdleCallback
       directly from init(), which runs at DOMContentLoaded — well
       before the page's own images/stylesheets have finished loading.
       rIC only promises "no pending JS task on the main thread," not
       "the page is done loading," so on a bandwidth-constrained
       connection it could (and, profiled under throttling, did) fire
       while this page's own hero image / render-blocking CSS were
       still in flight, adding up to 5 concurrent rel=prefetch document
       requests competing for the same limited pipe. rel=prefetch is
       scheduled at the lowest priority so it never blocks rendering —
       but bandwidth itself was still the bottleneck, and every
       concurrent request shares it regardless of priority.

       Fix: don't even register the idle callback until the browser's
       `load` event — i.e. until this page's own critical path has
       entirely finished. Zero contention with the current page, at the
       cost of prefetching starting a little later, which is the right
       trade for a feature whose whole point is making the NEXT
       navigation fast, not this one. */
    function startIdlePrefetch() {
      var rIC = typeof requestIdleCallback === 'function'
        ? requestIdleCallback
        : function (cb) { setTimeout(cb, 200); };

      rIC(function () {
        PAGES.forEach(function (href) {
          /* Skip the current page — it's already loaded */
          if (window.location.pathname === href) return;
          /* Skip if browser has a slow connection or prefers reduced data */
          var conn = navigator.connection;
          if (conn && (conn.saveData || conn.effectiveType === '2g' || conn.effectiveType === 'slow-2g')) return;
          /* Avoid duplicate <link> tags */
          if (document.querySelector('link[rel="prefetch"][href="' + href + '"]')) return;

          var link = document.createElement('link');
          link.rel  = 'prefetch';
          link.href = href;
          link.as   = 'document';
          document.head.appendChild(link);
        });
      }, { timeout: 3000 });
    }

    if (document.readyState === 'complete') {
      startIdlePrefetch();
    } else {
      window.addEventListener('load', startIdlePrefetch, { once: true });
    }
  }

  /* ════════════════════════════════════════════════════════════════
     7. WAITLIST PROGRESS BAR — real, static, merchant-controlled count
     Was a localStorage-persistent "organic" auto-incrementing counter
     (random +1–4 step every 5 minutes, wrapping back down on overflow)
     with no connection whatsoever to actual signups — fake scarcity.
     Replaced with what it should have been: render the real count
     Shopify Theme Settings already holds (Theme Settings -> Progress
     bar -> "First Batch capacity" / "Progress bar starting count",
     rendered onto #ph-progress-bar as data attributes by
     sections/phalanx-launch.liquid) once, honestly, with no simulated
     ticking. The merchant updates the number in Theme Editor as real
     signups come in; this only animates the bar's fill-in reveal when
     it scrolls into view (a transition, not a data change).
  ════════════════════════════════════════════════════════════════ */
  function initCounter() {
    var progBar   = document.getElementById('ph-progress-bar');
    var progFill  = document.getElementById('ph-progress-fill');
    if (!progBar || !progFill) return;

    var goal  = +progBar.dataset.waitlistGoal || 500;
    var count = +progBar.dataset.waitlistStart || 0;
    var pct   = (count / goal * 100).toFixed(1) + '%';

    var progSection = progFill.closest('.ph-progress');
    if (progSection && 'IntersectionObserver' in window) {
      var progIO = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          progFill.style.width = pct;
          progIO.disconnect();
        }
      }, { threshold: 0.2 });
      progIO.observe(progSection);
    } else {
      progFill.style.width = pct;
    }
  }

  /* ════════════════════════════════════════════════════════════════
     8. BACK TO TOP — discreet footer link, shared across all 7 pages
  ════════════════════════════════════════════════════════════════ */
  function initBackToTop() {
    var btn = document.querySelector('.ph-back-to-top');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  /* ════════════════════════════════════════════════════════════════
     9. HONEYPOT SPAM GUARD — hero / collection / footer waitlist forms
     Any form containing a .ph-honeypot field: if that field has a
     value on submit (a real visitor never fills it in, per the CSS),
     silently block the submission — no error shown, since the point
     is to give a bot nothing to react to.
  ════════════════════════════════════════════════════════════════ */
  /* ════════════════════════════════════════════════════════════════
     COPY LINK — shared "Kopiera länk" action (see the .ph-copy-link
     component in phalanx-global.css). One delegated document-level
     listener, so any button anywhere marked up with
     data-copy-link="target-id" works automatically — Vetenskap
     ingredients, the FAQ's own injected buttons (phalanx-launch.liquid
     initFaq), any future use — with no per-page JS. Same shape as the
     waitlist share button's existing "kopierad" flow: swap the label,
     revert after a pause, fail silently rather than surface a
     technical clipboard error.
  ════════════════════════════════════════════════════════════════ */
  function initCopyLinkButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-copy-link]');
      if (!btn || btn.dataset.phCopyBusy) return;
      var targetId = btn.getAttribute('data-copy-link');
      if (!targetId) return;

      var url = window.location.href.split('#')[0] + '#' + targetId;
      var labelEl = btn.querySelector('[data-copy-link-label]') || btn;
      var originalText = labelEl.textContent;

      function confirm() {
        btn.dataset.phCopyBusy = 'true';
        btn.classList.add('ph-copy-link--done');
        labelEl.textContent = 'Kopierad';
        setTimeout(function () {
          labelEl.textContent = originalText;
          btn.classList.remove('ph-copy-link--done');
          delete btn.dataset.phCopyBusy;
        }, 2000);
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url).then(confirm).catch(function () {
          /* Graceful fallback, no exposed error: at least put the
             visitor at the right in-page anchor. */
          window.location.hash = targetId;
        });
      } else {
        window.location.hash = targetId;
      }
    });
  }

  /* ════════════════════════════════════════════════════════════════
     GLOSSARY — click/tap/keyboard-activated definitions for the small
     set of scientific-methodology terms wrapped by snippets/phalanx-
     glossary-wrap.liquid (Vetenskap study "design" field). ONE shared
     popover element for the whole page rather than one per term;
     positioned under the clicked term, dismissed by Escape, an
     outside click, or activating the same term again. Never hover-
     triggered, so it behaves identically for touch and keyboard.
  ════════════════════════════════════════════════════════════════ */
  function initGlossary() {
    var terms = document.querySelectorAll('.ph-gloss-term');
    if (!terms.length) return;

    var popover = document.createElement('div');
    popover.className = 'ph-gloss-popover';
    popover.setAttribute('role', 'status');
    popover.id = 'ph-gloss-popover';
    popover.hidden = true;
    document.body.appendChild(popover);

    var openTrigger = null;

    function close() {
      popover.hidden = true;
      if (openTrigger) {
        openTrigger.setAttribute('aria-expanded', 'false');
        openTrigger.removeAttribute('aria-describedby');
      }
      openTrigger = null;
    }

    function openFor(trigger) {
      var term = trigger.getAttribute('data-gloss-term') || '';
      var def  = trigger.getAttribute('data-gloss-def') || '';
      if (!def) return;
      popover.innerHTML =
        '<span class="ph-gloss-popover__term">' + term + '</span>' + def;
      popover.hidden = false;

      var rect = trigger.getBoundingClientRect();
      var top = rect.bottom + 8;
      var left = Math.min(rect.left, window.innerWidth - popover.offsetWidth - 16);
      left = Math.max(left, 16);
      /* Flip above the term if there isn't room below (e.g. a term
         near the bottom of the viewport). */
      if (top + popover.offsetHeight > window.innerHeight - 16) {
        top = rect.top - popover.offsetHeight - 8;
      }
      popover.style.top = top + 'px';
      popover.style.left = left + 'px';

      trigger.setAttribute('aria-expanded', 'true');
      trigger.setAttribute('aria-describedby', popover.id);
      openTrigger = trigger;
    }

    terms.forEach(function (term) {
      term.setAttribute('aria-expanded', 'false');
      term.addEventListener('click', function (e) {
        e.stopPropagation();
        if (openTrigger === term) {
          close();
        } else {
          openFor(term);
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (openTrigger && !popover.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openTrigger) {
        var trigger = openTrigger;
        close();
        trigger.focus();
      }
    });
    window.addEventListener('resize', function () {
      if (openTrigger) openFor(openTrigger);
    }, { passive: true });
  }

  /* ════════════════════════════════════════════════════════════════
     CONTACT CONTEXT — a "Fråga om X" link elsewhere on the site
     (?angaende=X on the Contact page URL) prefills the message
     textarea with a visible, still fully editable opening line, and
     shows a small dismissable chip explaining why. Reads the URL only
     on the Contact page itself; no data leaves the browser until the
     visitor submits the form themselves, and no extra personal data is
     collected — this only shapes the same free-text field the native
     contact form already has.
  ════════════════════════════════════════════════════════════════ */
  function initContactContext() {
    var textarea = document.querySelector('.ph-contact-textarea');
    var chip = document.getElementById('ph-contact-context');
    if (!textarea || !chip) return;

    var params = new URLSearchParams(window.location.search);
    var context = params.get('angaende');
    if (!context || textarea.value.trim()) return; /* never overwrite a returning form.body */

    context = context.slice(0, 80); /* sanity cap, this is a Liquid link we control, not untrusted input */
    var prefix = 'Angående: ' + context + '\n\n';
    textarea.value = prefix;

    chip.hidden = false;
    chip.querySelector('.ph-contact-context__text').textContent = 'Ditt meddelande är förifyllt: ' + context;
    chip.querySelector('.ph-contact-context__clear').addEventListener('click', function () {
      if (textarea.value === prefix) textarea.value = '';
      chip.hidden = true;
    });

    /* Put the cursor after the prefilled line, ready to type. */
    textarea.focus();
    textarea.setSelectionRange(textarea.value.length, textarea.value.length);
  }

  /* ════════════════════════════════════════════════════════════════
     SERVINGS CALCULATOR — pure arithmetic (servings ÷ uses-per-week
     ≈ weeks), reading the canonical product_servings text setting via
     a data attribute rather than a second, separately-maintained
     number. No recommendation language is generated here — the result
     is always phrased as an estimate.
  ════════════════════════════════════════════════════════════════ */
  function initServingsCalculator() {
    var calcs = document.querySelectorAll('.phd-calc');
    calcs.forEach(function (calc) {
      var raw = calc.getAttribute('data-servings') || '';
      var match = raw.match(/\d+/);
      var servings = match ? parseInt(match[0], 10) : 0;
      var select = calc.querySelector('.phd-calc__select');
      var result = calc.querySelector('[data-calc-result]');
      if (!servings || !select || !result) return;

      function update() {
        var perWeek = parseInt(select.value, 10) || 1;
        var weeks = Math.round((servings / perWeek) * 10) / 10;
        var label = weeks === 1 ? 'vecka' : 'veckor';
        result.textContent = '≈ ' + weeks + ' ' + label;
      }
      select.addEventListener('change', update);
      update();
    });
  }

  /* ════════════════════════════════════════════════════════════════
     READING LIST — a local, no-account "save for later" list for
     scientific/ingredient content and the Formula 48 reference card.
     localStorage only: nothing leaves this browser/device, no
     tracking, no personal data. Deliberately discreet — the indicator
     only appears once at least one item is saved.
  ════════════════════════════════════════════════════════════════ */
  function initReadingList() {
    var triggers = document.querySelectorAll('[data-reading-save]');
    if (!triggers.length) return;

    var STORAGE_KEY = 'phalanx_reading_list';

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
    function getList() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (e) { return []; }
    }
    function setList(list) {
      try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
    }
    function isSaved(id, list) {
      return list.some(function (item) { return item.id === id; });
    }

    var indicator, panel;

    function ensureUI() {
      if (indicator) return;
      indicator = document.createElement('button');
      indicator.type = 'button';
      indicator.className = 'ph-reading-indicator';
      indicator.id = 'ph-reading-indicator';
      indicator.hidden = true;
      indicator.setAttribute('aria-haspopup', 'true');
      indicator.setAttribute('aria-expanded', 'false');
      document.body.appendChild(indicator);

      panel = document.createElement('div');
      panel.className = 'ph-reading-panel';
      panel.id = 'ph-reading-panel';
      panel.hidden = true;
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-label', 'Sparade artiklar');
      document.body.appendChild(panel);

      indicator.addEventListener('click', function () {
        var willOpen = panel.hidden;
        if (willOpen) renderPanel();
        panel.hidden = !willOpen;
        indicator.setAttribute('aria-expanded', String(willOpen));
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) {
          panel.hidden = true;
          indicator.setAttribute('aria-expanded', 'false');
          indicator.focus();
        }
      });
      document.addEventListener('click', function (e) {
        /* composedPath() is captured at dispatch time, so it still
           includes `panel` even when a remove/clear-all handler inside
           the panel replaces panel.innerHTML (detaching e.target)
           before this listener runs — panel.contains(e.target) would
           wrongly read as "outside" once the target is detached and
           slam the panel shut right after removing an item. */
        var path = e.composedPath ? e.composedPath() : [];
        var insidePanel = path.indexOf(panel) !== -1 || panel.contains(e.target);
        if (!panel.hidden && !insidePanel && e.target !== indicator) {
          panel.hidden = true;
          indicator.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function syncButtons() {
      var list = getList();
      triggers.forEach(function (btn) {
        var id = btn.getAttribute('data-reading-id');
        var saved = isSaved(id, list);
        btn.textContent = saved ? 'Sparad' : 'Spara';
        if (saved) btn.setAttribute('data-reading-saved', 'true');
        else btn.removeAttribute('data-reading-saved');
      });
      ensureUI();
      if (list.length) {
        indicator.hidden = false;
        indicator.textContent = 'Sparade (' + list.length + ')';
      } else {
        indicator.hidden = true;
        panel.hidden = true;
      }
    }

    function renderPanel() {
      var list = getList();
      if (!list.length) {
        panel.innerHTML = '<p class="ph-reading-panel__empty">Inga sparade artiklar ännu.</p>';
        return;
      }
      var html = '<p class="ph-reading-panel__note">Sparat i den här webbläsaren — inget konto, ingen delning med andra enheter.</p><ul class="ph-reading-panel__list">';
      list.forEach(function (item) {
        html += '<li><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>' +
          '<button type="button" class="ph-reading-panel__remove" data-remove-id="' + escapeHtml(item.id) + '" aria-label="Ta bort ' + escapeHtml(item.title) + '">×</button></li>';
      });
      html += '</ul><button type="button" class="ph-reading-panel__clear" data-clear-all>Rensa allt</button>';
      panel.innerHTML = html;

      panel.querySelectorAll('[data-remove-id]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setList(getList().filter(function (i) { return i.id !== btn.getAttribute('data-remove-id'); }));
          syncButtons();
          renderPanel();
        });
      });
      var clearBtn = panel.querySelector('[data-clear-all]');
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          setList([]);
          syncButtons();
          renderPanel();
        });
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-reading-save]');
      if (!btn) return;
      var id = btn.getAttribute('data-reading-id');
      if (!id) return;
      var list = getList();
      if (isSaved(id, list)) {
        list = list.filter(function (i) { return i.id !== id; });
      } else {
        list.push({
          id: id,
          title: btn.getAttribute('data-reading-title') || id,
          url: btn.getAttribute('data-reading-url') || ('#' + id),
        });
      }
      setList(list);
      syncButtons();
    });

    syncButtons();
  }

  /* ════════════════════════════════════════════════════════════════
     PRINT TRIGGER — generic [data-print-trigger] → window.print(),
     shared by the Formula 48 card's "Skriv ut" action (and anything
     else that reasonably wants the same behaviour later).
  ════════════════════════════════════════════════════════════════ */
  function initPrintTriggers() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-print-trigger]');
      if (!btn) return;
      window.print();
    });
  }

  /* ════════════════════════════════════════════════════════════════
     BATCH LOOKUP (#47/#96) — exact client-side match against the
     batch rows Liquid already rendered (sections/phalanx-quality.liquid).
     No network request, no fabricated data: a batch number either
     matches one of this page's own real rows, or the visitor sees the
     explicit "not found" message. Never falls back to a different
     batch's row.
  ════════════════════════════════════════════════════════════════ */
  function initBatchLookup() {
    var forms = document.querySelectorAll('[data-batch-search-form]');
    forms.forEach(function (form) {
      var section = form.closest('[data-batch-lookup]');
      if (!section) return;
      var input = form.querySelector('[data-batch-search-input]');
      var notFound = form.querySelector('[data-batch-not-found]');
      var rows = section.querySelectorAll('[data-batch-row]');

      function showAll() {
        rows.forEach(function (row) { row.hidden = false; });
        notFound.hidden = true;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var query = (input.value || '').trim().toLowerCase();
        if (!query) { showAll(); return; }

        var matched = false;
        rows.forEach(function (row) {
          var isMatch = row.getAttribute('data-batch-number') === query;
          row.hidden = !isMatch;
          if (isMatch) matched = true;
        });
        notFound.hidden = matched;
      });

      input.addEventListener('input', function () {
        if (input.value.trim() === '') showAll();
      });
    });
  }

  function initHoneypot() {
    var traps = document.querySelectorAll('.ph-honeypot input');
    traps.forEach(function (trap) {
      var form = trap.closest('form');
      if (!form) return;
      form.addEventListener('submit', function (e) {
        if (trap.value !== '') {
          e.preventDefault();
        }
      });
    });
  }

  /* ════════════════════════════════════════════════════════════════
     BOOTSTRAP
  ════════════════════════════════════════════════════════════════ */
  function init() {
    initFormValidation(); /* before other inits so noValidate is set before any interaction */
    initCounter();        /* renders the real waitlist progress bar fill */
    initPageTransitions();
    initMagneticButtons();
    initFadeIn();
    initCascade();      /* after initFadeIn so ph-ci is added before IO fires */
    initImageLoadFade();
    initImgSurfaceReveal();
    initScrollProgress();
    initSmoothScroll();
    initPrefetch();     /* idle-time prefetch of all five Phalanx pages */
    initBackToTop();
    initHoneypot();
    initCopyLinkButtons();
    initGlossary();
    initContactContext();
    initServingsCalculator();
    initReadingList();
    initPrintTriggers();
    initBatchLookup();
    initCtaClickEvents();
    initWaitlistSuccessEvent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
